import React from 'react';
import PcAuthProvider from './PcAuthProvider';
const PortalAuthProvider = ({ children }) => <PcAuthProvider>{children}</PcAuthProvider>;

export default PortalAuthProvider;
